var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeavy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "265.9 -55.4 23 24.5",
    enableBackground: "new 265.9 -55.4 23 24.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -371.8,
    y: -345,
    width: 969.8,
    height: 713.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 511.5,
    y: 370.4,
    width: 75.1,
    height: 29.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -3.051758e-05)",
    clipPath: "url(#SVGID_4_)"
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 1710,
    height: 1276,
    xlinkHref: "Screen Shot 2014-08-07 at 1.16.05 PM.png",
    transform: "matrix(0.6175 0 0 0.6175 -345.4638 -358.1656)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "customer_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3B",
    d: "M275.9-51.5c0,0.9,0.6,1.5,1.5,1.5c0.9,0,1.5-0.6,1.5-1.5s-0.6-1.5-1.5-1.5 C276.5-53,275.9-52.3,275.9-51.5z M281.2-51.5c0,2.2-1.7,3.9-3.9,3.9c-2.2,0-3.9-1.7-3.9-3.9s1.7-3.9,3.9-3.9 C279.5-55.4,281.2-53.6,281.2-51.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3B",
    d: "M285.3-46.6c-0.2-1.2-1.4-2.2-2.6-2.2h-3.2c-1.2,0-2.2,0-2.2,0s-1,0-2.2,0H272c-1.2,0-2.4,1-2.6,2.2 L266.8-34c-0.2,1.2,0.5,2.2,1.7,2.2h6.1c1.2,0,2.4,0,2.7,0c0.3,0,1.5,0,2.7,0h6.1c1.2,0,1.9-1,1.7-2.2L285.3-46.6z"
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 274.9069 -34.0165)",
    fill: "#FFFFFF",
    fontFamily: "'OpenSans-Extrabold'",
    fontSize: 17
  }, "!"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol_4"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol_3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeavy);
export default __webpack_public_path__ + "static/media/heavy.d4064d38c3c30299657a316d42d6536a.svg";
export { ForwardRef as ReactComponent };